import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import socket from '../Utils/soket';
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IoSend } from "react-icons/io5";
import toast from 'react-hot-toast';
import { newCount, newNotification} from '../Reducer/notificationReducer';
import { DEFAULTIMAGEURL, IMAGEURL } from '../Utils/EndPoint';

const RightSide = ({ selectedChat, message = "", allMessage, setSelectedChat, setMessage, handleSendMessage, clearChat }) => {
    const scrollContainerRef = useRef(null);
    const dropdownRef = useRef(null);
    const user = useSelector((state) => state.Auth.user);
    const [isSending, setIsSending] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { allNotification } = useSelector((state) => state.Notification);

    const typingTimeoutRef = useRef(null);
    const dispatch = useDispatch();
    const scrollToBottom = useCallback(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: scrollContainerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, []);
    const notificationCheck = async () => {
        const filteredNotifications = [];
        
        for (const notification of allNotification) {
          if (notification?._id !== selectedChat?._id) {
            filteredNotifications.push(notification);
          }
        }
        dispatch(newNotification(filteredNotifications))
        const data = filteredNotifications?.length ?? 0 
        dispatch(newCount(data))
        return filteredNotifications;
      };
      
      useEffect(() => {
        notificationCheck();
      }, [selectedChat]);

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const timeout = setTimeout(scrollToBottom, 100);
        return () => clearTimeout(timeout);
    }, [allMessage, scrollToBottom]);

    useEffect(() => {
        const handleTyping = () => setIsTyping(true);
        const handleStopTyping = () => setIsTyping(false);

        socket.on("typing", handleTyping);
        socket.on("stop typing", handleStopTyping);

        return () => {
            socket.off("typing", handleTyping);
            socket.off("stop typing", handleStopTyping);
        };
    }, []);

    const handleTyping = (e) => {
        setMessage(e.target?.value);
        socket.emit("typing", selectedChat._id);

        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

        typingTimeoutRef.current = setTimeout(() => {
            socket.emit("stop typing", selectedChat._id);
        }, 3000);
    };

    const handleSendMessageWrapper = async (e) => {
        e.preventDefault();
        if (message.trim() === "") {
           toast.error("Please enter a message before sending.");
            return;
        }
        if (isSending) return;

        setIsSending(true);
        await handleSendMessage();
        setIsSending(false);
    };

    const sortedMessages = [...allMessage].sort((a, b) =>
        new Date(a.createdAt) - new Date(b.createdAt)
    );

    const groupMessagesByDate = (messages) => {
        return messages.reduce((acc, message) => {
            const date = moment(message.createdAt).format("YYYY-MM-DD");
            if (!acc[date]) acc[date] = [];
            acc[date].push(message);
            return acc;
        }, {});
    };

    const groupedMessages = groupMessagesByDate(sortedMessages);

    return (
        <div className='right w-1/2 side border rounded-sm'>
            {selectedChat ? (
                <>
                    <div className="flex justify-between items-center p-4 border-b bg-gray-100">
                        <div className='flex items-center flex-shrink-0'>
                            <img
                                src={selectedChat.otherUser.image
                                    ? `${IMAGEURL}/${selectedChat.otherUser.image}`
                                    : DEFAULTIMAGEURL}
                                alt={`${selectedChat.otherUser.firstName}'s profile`}
                                className='w-10 h-10 rounded-full object-cover'
                            />
                            <h2 className="ms-2 text-lg font-bold text-gray-900">
                                {selectedChat.otherUser.firstName + " " + selectedChat.otherUser.lastName}
                            </h2>
                        </div>

                        <div ref={dropdownRef} className="relative">
                            <BiDotsVerticalRounded
                                onClick={toggleDropdown}
                                className="text-gray-500 cursor-pointer hover:text-gray-700"
                                size={20}
                            />
                            {isDropdownOpen && (
                                <div className="absolute right-3 top-[50%] w-40 bg-white border rounded shadow-lg z-20">
                                    <button
                                        onClick={() => {
                                            clearChat();
                                            setIsDropdownOpen(false);
                                        }}
                                        className={`block w-full text-left px-4 py-2 ${allMessage.length === 0
                                                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                : "hover:bg-gray-100 cursor-pointer"
                                            }`}
                                        disabled={allMessage.length === 0}
                                    >
                                        Clear Chat
                                    </button>
                                    <button
                                        onClick={() => (setSelectedChat(null), setIsDropdownOpen(false))}
                                        className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                                    >
                                        Close Chat
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div ref={scrollContainerRef} className="p-4 overflow-y-auto h-[55vh]">
                        {Object.keys(groupedMessages).map((date) => (
                            <div key={date} className="relative">
                                <div className="sticky top-0 bg-gray-100 py-1 text-center text-sm text-gray-500 z-10">
                                    {moment(date).format("dddd, MMMM Do YYYY")}
                                </div>
                                {groupedMessages[date].map((msg) => (
                                    <div key={msg._id} className="flex flex-col">
                                        {msg.senderId === user._id ? (
                                            <div className="flex justify-end">
                                                <div className="max-w-[60%] p-2 my-2 bg-gray-200 rounded-lg">
                                                    <p>{msg.message}</p>
                                                    <span className="text-xs text-gray-500 mt-1 block text-right">
                                                        {moment(msg.createdAt).format("h:mm A")}
                                                    </span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex justify-start">
                                                <div className="max-w-[60%] p-2 my-2 bg-blue-500 text-white rounded-lg">
                                                    <p>{msg.message}</p>
                                                    <span className="text-xs text-gray-300 mt-1 block text-left">
                                                        {moment(msg.createdAt).format("h:mm A")}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                        {isTyping && (
                            <div className="text-gray-500 text-sm text-center mb-2">
                                {selectedChat.otherUser.firstName} is typing...
                            </div>
                        )}
                        {allMessage.length === 0 && (
                            <div className="text-center text-gray-500 mt-4">
                                No messages yet. Start the conversation!
                            </div>
                        )}
                    </div>

                    <div>
                        <form className="flex items-center p-4 border-t bg-gray-50" onSubmit={handleSendMessageWrapper}>
                            <input
                                type="text"
                                value={message}
                                onChange={(e) => {
                                    handleTyping(e);
                                    
                                }}
                                placeholder="Type a message"
                                className="w-full p-2 border rounded-md"
                            />
                            <button
                                type='submit'
                                className={`bg-blue-500 hover:bg-blue-700 ms-2 text-white p-2 rounded-md ${isSending && "opacity-50"}`}
                                disabled={isSending}
                                >
                                <IoSend size={20} />
                            </button>
                        </form>
                    </div>
                </>
            ) : (
                <div className="h-full text-black flex justify-center items-center font-semibold">
                    <h1>Select a chat to start messaging</h1>
                </div>
            )}
        </div>
    );
};

export default RightSide;
